// extracted by mini-css-extract-plugin
export default {"story-cards-embedded":"story-cards-embedded--kI_Vt","storyCardsEmbedded":"story-cards-embedded--kI_Vt","blink":"blink--HSaAA"};